import React, { useState } from 'react';
import { Button, Dropdown } from 'react-bootstrap';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import _ from 'lodash';
import { useSelector, useDispatch } from 'react-redux';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { useHistory } from 'react-router-dom';
import Spinner from '../../../SharedModules/Spinner/SpinnerNew';
import SVGComponent from '../../../SharedModules/SVGComponents/SVGComponents';
import CustomSeparator from '../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import ViewHistoryComponent from '../../../SharedModules/MicroFrontend/ViewHistoryComponent';
import SaveCancelPopup from '../../../SharedModules/CustomSaveCancelPopup/SaveCancelPopup';

import CommentAndCorrespondenceComponent from '../../../SharedModules/MicroFrontend/CommentAndCorrespondenceComponent';
import {
  setCurrentNDCDetailsSelected,
  setCurrentNDCDetailsIndex,
  setNDCErrorPopupMessage,
  getNDCDetails,
  setNDCDetails,
} from '../../Display/NDC/store/action';
import {
  getClaimTableInfo,
  setDisplayClaimSearchScreenObj,
  setSelectedClaim,
  setSelectedClaimMode,
} from '../../Display/Claim/store/action';
import {
  getProviderDetails,
  callSearchClaimAPI,
} from '../../Research/ClaimAudits/store/actions';
import {
  dispatchProvideDetails,
  getProviderIdTypeDetails,
} from '../../Display/Provider/store/action';
import {
  onCellFocused,
  navigateToNextCell,
  tabToNextCell,
} from '../../../SharedModules/AgGridUtilities/suppressNavigation';
import TableGrid from '../../../SharedModules/Table/TableGridWithFeatures';
import { PRDetailTableHead2 } from './gridComponents/PRDetailsSecondTable';
import { PRDetailTableHead1 } from './gridComponents/PRDetailsFirstTable';

import {
  getProviderDropDown,
  getNdcMainGridDetail,
  updateProviderFrozenComplete,
  dispatchGetDetailData,
  getProviderReviewClaimHeader,
  getReviewCorrectionDropdown,
  getReviewProblemDropdown,
  handleErrorMessages,
  dispatchProviderReviewClaimHeader,
  dispatchProblemCode,
  dispatchcorrectionCode,
  dispatchBottonState,
} from './Store/actions';
import { viewPortHeight_355 } from '../../../SharedModules/CommonConstants/commonConstants';
import DisplaySuccessMessages from '../../../SharedModules/Errors/SuccessMessage';
import DisplayErrorMessages from '../../../SharedModules/Errors/ErrorMessages';
import PRDetailsForm from './gridComponents/PRDetailsForm';
import CorrectionCodeDropdown from './gridComponents/CorrectionCodeDropdown';
import ProblemCodeDropdown from './gridComponents/ProblemCodeDropdown';
import CommentVisibleIcon from '../../../assets/images/commen-visible-icon.svg';
import CommentIcon from '../../../assets/images/comment-dots.svg';
import {
  redirectURLLink,
  closeTab,
  handleQuarterFormate,
  handleScrollToEvent,
} from '../../../SharedModules/CommonUtilities/commonUtilities';

import * as constantMessageData from '../../../SharedModules/Errors/constantMessageData';
import { checkActionAccessByRole } from '../../../SharedModules/utilities/utilities';

function ProviderReviewDetail() {
  const history = useHistory();
  const dispatch = useDispatch();
  const errorMessagesInRedux = useSelector(
    (state) => state.sharedState.ProviderReviewReducer?.errorMessagesInRedux
  );
  // 2nd Screen 1st Table : NDC
  const getNdcMainGridDetails = useSelector(
    (val) => val.sharedState.ProviderReviewReducer?.getNdcMainGridDetail
  );

  // on 1st screen table data double click: Header form Value
  const getProviderList = useSelector(
    (state) => state.sharedState.ProviderReviewReducer?.getProviderList
  );
  const getButtonState = useSelector(
    (state) => state.sharedState.ProviderReviewReducer?.getButtonState
  );

  const setDetailData = (value) => dispatch(dispatchGetDetailData(value));

  // maintain redux/state for second screen
  const getDetailData = useSelector(
    (state) => state.sharedState.ProviderReviewReducer?.getDetailData
  );

  // 2nd Screen 2nd Table : claim
  const getproviderReviewClaimHeader = useSelector(
    (state) =>
      state.sharedState.ProviderReviewReducer?.getProviderReviewClaimHeader
  );
  const getProviderFrozenComplete = useSelector(
    (state) =>
      state.sharedState.ProviderReviewReducer?.getProviderFrozenComplete
  );
  const getProblemCode = useSelector(
    (state) => state.sharedState.ProviderReviewReducer?.getProblemCode
  );
  const getCorrectionCode = useSelector(
    (state) => state.sharedState.ProviderReviewReducer?.getCorrectionCode
  );
  const providerIdTypeDropDown = useSelector(
    (state) => state?.sharedState?.ProviderReducer?.providerIdType
  );

  // comment redux
  const commentsList = useSelector((state) => {
    return state.sharedState.CommentsReducer.commentData;
  });

  const { kcRoles } = useSelector((state) => state.sharedState.SharedReducer);
  const logInUser = useSelector(
    (state) => state?.sharedState?.SharedReducer?.logInUser
  );
  const [probelemDropDownReview, setProblemDownReview] = useState([]);
  const [correctionDropDownReview, setCorrectionDownReview] = useState([]);
  const [gridParams, setGridParams] = useState('');
  const [providerIdTypeDesc, setProviderIdTypeDesc] = useState('');
  const [gridApi, setGridApi] = useState(null);
  const [tableData, setTableData] = useState();
  const [formDropDown, setFormDropDown] = useState([]);
  const updateTabs = JSON.parse(localStorage.getItem('tabItemsData'));
  const [showComments, setShowComments] = React.useState(false);
  const [showFormComments, setShowFormComments] = React.useState(false);
  const [linkTableName, setLinkTableName] = useState('PROVIDER_REVIEW');
  const [linkFormTableName, setLinkFormTableName] = useState('PROVIDER_REVIEW');
  const [showViewHistory, setShowViewHistory] = useState(false);
  const [saveView, setSaveView] = React.useState(false);
  const [cancelView, setCancelView] = React.useState(false);
  const [tableName, setTableName] = useState('PROVIDER_REVIEW');
  const [tableFormName, setTableFormName] = useState('PROVIDER_REVIEW');
  const [keyValue, setKeyValue] = useState([]);
  const [providerDropDown, setProviderDropDown] = useState([]);
  const [loading, setLoading] = useState(true);
  const [corrLinkId, setCorrLinkId] = useState(null);
  const [corrLinkFormId, setCorrLinkFormId] = useState(null);
  const [correctionTableData, setCorrectionTableData] = useState([]);
  const [formData, setFormData] = useState({});
  const [fullScreenView, setfullScreenView] = useState(false);
  const [fullScreenView1, setFullScreenView1] = useState(false);
  const [state, setState] = useState(null);
  const [correctionState, setCorrectionState] = useState(null);
  const [handleTab, setHandleTab] = React.useState(false);
  const [selectedRow, setSelectedRow] = React.useState({});
  const RedColor='#a81f00';

  //get detail data main redux
  const [disableSaveCancel, setDisableSaveCancel] = React.useState(
    getDetailData?.disablemajorButton
      ? getDetailData?.disablemajorButton
      : false
  );

  const [formValue, setFormValue] = useState(
    getDetailData?.formValue
      ? getDetailData?.formValue
      : {
          frozenindex: false,
          completeIndex: false,
          reviewTypeCd: '-1',
          ccCommentsExist: 0,
          providerIdTypeCD: '',
          providerId: '',
          nabpNum: '',
          name: '',
          ccClaimCount: '',
        }
  );

  const [isEnablebyRole, setIsEnablebyRole] = React.useState(
    checkActionAccessByRole(process.env.REACT_APP_STATE_ONLY_ROLE, kcRoles)
  );

  //------------------------------------------

  React.useEffect(() => {
    if (kcRoles?.userPrivileges.length > 0) {
      setIsEnablebyRole(
        checkActionAccessByRole(process.env.REACT_APP_STATE_ONLY_ROLE, kcRoles)
      );
    }
  }, []);

  React.useEffect(() => {
    setLoading(true);
    const result = dispatch(
      getProviderDropDown({ codeDomainList: ['REVIEW_TYPE_CD'] })
    );
    result.then((item) => {
      setFormDropDown(item);
    });
    handleScrollToEvent();
  }, []);

  //----------------------------------------------------------
  React.useEffect(() => {
    let list = [];
    if (!_.isEmpty(formDropDown)) {
      list = _.map(formDropDown?.REVIEW_TYPE_CD, (val) => {
        return {
          ...val,
          id: val.codeValueID?.codeValue,
          name: `${val.codeValueID?.codeValue} | ${val.shortDescription}`,
        };
      });
    }
    setProviderDropDown(
      list.sort((key, val) =>
        key.name.toLowerCase().localeCompare(val.name.toLowerCase())
      )
    );
  }, [formDropDown]);
  // ------------------------------------------comment save api
  React.useEffect(() => {
    const tempObj =
      getproviderReviewClaimHeader &&
      getproviderReviewClaimHeader.map((item) => {
        if (
          item.corrLinkId === corrLinkId &&
          commentsList &&
          commentsList.length > 0
        ) {
          item.ccCommentsExist = 1;
        } else if (item.corrLinkId === corrLinkId) {
          item.ccCommentsExist = 0;
        }
        return item;
      });
    setTableData(tempObj);
    dispatch(dispatchProviderReviewClaimHeader(tempObj));
    if (gridParams && gridParams.api) {
      gridParams.api.refreshCells();
    }
  }, [commentsList]);
  //------------------------------------------
  React.useEffect(() => {
    if (getProviderList && Object.keys(getProviderList).length > 0) {
      setFormData(getProviderList[0]);
      if (Object.keys(getDetailData).length === 0) {
        if (
          getProviderList[0]?.reviewFreezeDt ||
          getProviderList[0]?.auditCompleteDt
        ) {
          setFormValue({
            ...formValue,
            frozenindex: getProviderList[0]?.reviewFreezeDt ? true : false,
            completeIndex: getProviderList[0]?.auditCompleteDt ? true : false,
            reviewTypeCd: getProviderList[0]?.reviewTypeCd,
            correctionCode: '-1',
            problemCode: '-1',
            ccCommentsExist: getProviderList[0]?.ccCommentsExist,
          });
          setDetailData({
            formValue: {
              ...formValue,
              frozenindex: getProviderList[0]?.reviewFreezeDt ? true : false,
              completeIndex: getProviderList[0]?.auditCompleteDt ? true : false,
              reviewTypeCd: getProviderList[0]?.reviewTypeCd,
              correctionCode: '-1',
              problemCode: '-1',
            },
          });
        } else {
          setFormValue({
            ...formValue,
            frozenindex: false,
            completeIndex: false,
            reviewTypeCd: getProviderList[0]?.reviewTypeCd,
            correctionCode: '-1',
            problemCode: '-1',
            ccCommentsExist: 0,
          });
          setDetailData({
            formValue: {
              ...formValue,
              frozenindex: false,
              completeIndex: false,
              reviewTypeCd: getProviderList[0]?.reviewTypeCd,
              correctionCode: '-1',
              problemCode: '-1',
            },
          });
        }
      }
      setLoading(false);
    }
  }, [getProviderList]);

  // handle after call service show success and error message
  React.useEffect(() => {
    if (
      getProviderFrozenComplete &&
      getProviderFrozenComplete.message === 'SUCESS'
    ) {
      setSaveView(false);
      setLoading(false);
      if (handleTab) {
        closeTab('/providerReviewDetail', history, dispatch);
      }

      var localErr = [];
      localErr.push({
        field: 'successMessage',
        errorType: 'successMessage',
        message: constantMessageData.SUCCESSMESSAGE_GENERIC,
      });
      dispatch(
        handleErrorMessages({
          detailScreenErrors: [...new Set(localErr)],
          searchScreenErrors: errorMessagesInRedux?.searchScreenErrors
            ? errorMessagesInRedux?.searchScreenErrors
            : [],
        })
      );
    } else if (
      getProviderFrozenComplete?.providerUpdateFrozenAndCompleteServiceResponse ===
      'failed'
    ) {
      setSaveView(false);
      setLoading(false);

      var localErrFail = errorMessagesInRedux?.detailScreenErrors
        ? errorMessagesInRedux?.detailScreenErrors
        : [];
      var localErrFail = localErrFail?.filter(
        (item) => item.errorType !== 'successMessage'
      );
      var localErrFail = localErrFail?.filter(
        (item) => item.errorType !== 'ApiFailed'
      );
      localErrFail.push({
        field: 'failedMessage',
        errorType: 'successMessage',
        message: constantMessageData.FAILED_MESSAGE_GENERIC,
      });

      dispatch(
        handleErrorMessages({
          detailScreenErrors: [...new Set(localErrFail)],
          searchScreenErrors: errorMessagesInRedux?.searchScreenErrors
            ? errorMessagesInRedux?.searchScreenErrors
            : [],
        })
      );
    }
  }, [getProviderFrozenComplete]);
  //------------------------------------------
  const cellValueUpdateCustom = React.useCallback((params) => {
    const p = {
      force: params.data,
    };
    params.api.refreshCells(p);
  }, []);
  //------------------------------------------
  React.useEffect(() => {
    if (getNdcMainGridDetails?.error === 'API failed') {
      let localErrFail = errorMessagesInRedux?.detailScreenErrors
        ? errorMessagesInRedux?.detailScreenErrors
        : [];
      localErrFail = localErrFail?.filter(
        (item) => item.errorType !== 'successMessage'
      );
      localErrFail.push({
        field: 'failedMessage',
        errorType: 'ApiFailed',
        message: constantMessageData.FAIL_PROCESSING_REQUEST,
      });
      dispatch(
        handleErrorMessages({
          detailScreenErrors: [...new Set(localErrFail)],
          searchScreenErrors: errorMessagesInRedux?.searchScreenErrors
            ? errorMessagesInRedux?.searchScreenErrors
            : [],
        })
      );
    }
  }, [getNdcMainGridDetail]);
  const getNdcTableData = React.useMemo(() => {
    let arr;
    if (!_.isEmpty(getNdcMainGridDetails?.recordProviderReviewResponse)) {
      arr = [
        {
          ...getNdcMainGridDetails?.recordProviderReviewResponse[0],
          drugSeqNum: `${getNdcMainGridDetails?.recordProviderReviewResponse[0]?.labelerCode}-${getNdcMainGridDetails?.recordProviderReviewResponse[0]?.productCode}-${getNdcMainGridDetails?.recordProviderReviewResponse[0]?.packageSize}`,
          qtr: handleQuarterFormate(
            getNdcMainGridDetails?.recordProviderReviewResponse[0]?.qtr
          ),
        },
      ];
    }
    setLoading(false);
    return arr;
  }, [getNdcMainGridDetails?.recordProviderReviewResponse]);
  //---------------------------------------------------------

  React.useEffect(() => {
    let list = [];
    if (!_.isEmpty(formDropDown)) {
      list = _.map(formDropDown?.REVIEW_TYPE_CD, (val) => {
        return {
          ...val,
          id: val.codeValueID?.codeValue,
          name: `${val.codeValueID?.codeValue} | ${val.shortDescription}`,
        };
      });
    }
    setProviderDropDown(
      list.sort((key, val) =>
        key.name.toLowerCase().localeCompare(val.name.toLowerCase())
      )
    );
  }, [formDropDown]);

  React.useEffect(() => {
    if (!handleTab) {
      const updateTabs = JSON.parse(localStorage.getItem('tabItemsData'));
      const newObj =
        updateTabs &&
        updateTabs.length > 0 &&
        updateTabs.map((item) => {
          if (item.navTo === '/providerReviewDetail' && !getButtonState) {
            item.isFormDirty = true;
          } else if (item.navTo === '/providerReviewDetail')
            item.isFormDirty = false;
          return item;
        });

      localStorage.setItem('tabItemsData', JSON.stringify(newObj));
    }
  }, [getButtonState]);

  //------------------------------------------
  React.useEffect(() => {
    if (
      getproviderReviewClaimHeader &&
      Object.keys(getproviderReviewClaimHeader).length > 0 &&
      getNdcMainGridDetails?.recordProviderReviewResponse.length > 0
    ) {
      setCorrectionTableData(getproviderReviewClaimHeader);
      setLoading(false);
    } else if (
      getproviderReviewClaimHeader &&
      Object.keys(getproviderReviewClaimHeader).length > 0 &&
      getNdcMainGridDetails?.recordProviderReviewResponse.length == 0
    ) {
      setCorrectionTableData([]);
    }
  }, [getproviderReviewClaimHeader]);
  //------------------------------------------
  const handleFullScreenView = () => {
    setfullScreenView(!fullScreenView);
  };
  const handleFullScreenView1 = () => {
    setFullScreenView1(!fullScreenView1);
    setfullScreenView(true);
  };
  //------------------------------------------
  const handleOnChangeEvent = (val, name) => {
    var localErrFail = errorMessagesInRedux?.detailScreenErrors
      ? errorMessagesInRedux?.detailScreenErrors
      : [];
    var localErrFail = localErrFail?.filter(
      (item) => item.errorType !== 'successMessage'
    );

    dispatch(
      handleErrorMessages({
        detailScreenErrors: [...new Set(localErrFail)],
        searchScreenErrors: errorMessagesInRedux?.searchScreenErrors
          ? errorMessagesInRedux?.searchScreenErrors
          : [],
      })
    );

    dispatch(dispatchBottonState(false));
    if (name === 'frozenindex') {
      setFormValue({ ...formValue, [name]: val });
      setDetailData({
        formValue: {
          ...formValue,
          [name]: val,
        },
      });
    }
    if (name === 'completeIndex') {
      setFormValue({ ...formValue, [name]: val });
      setDetailData({
        formValue: {
          ...formValue,
          [name]: val,
        },
      });
    }
    if (name === 'reviewTypeCd') {
      setFormValue({ ...formValue, [name]: val });
      setDetailData({
        formValue: {
          ...formValue,
          [name]: val,
        },
      });
    }
    setDisableSaveCancel(false);
  };
  // -------handle View History Popup-----------------------------------
  const handleViewHistory = () => {
    setShowViewHistory(true);
    const temp = {
      PROVIDER_ID: getProviderList[0].providerId,
      PROVIDER_ID_TYPE_CD: getProviderList[0].providerIdTypeCD,
    };
    setKeyValue(temp);
  };
  //------------------------------------------
  const redirectToNDC = async (cellInfo) => {
    const response = await getNDCDetails([
      { ndc: cellInfo?.drugSeqNum, drugName: cellInfo?.drugName },
    ]);

    if (response) {
      dispatch(setCurrentNDCDetailsSelected(response[0], 'All'));
      dispatch(setCurrentNDCDetailsIndex(1));
      dispatch(setNDCErrorPopupMessage(null));
      dispatch(
        setNDCDetails([
          { ndc: cellInfo?.drugSeqNum, drugName: cellInfo?.drugname },
        ])
      );
      redirectURLLink('/ndc-details', 'NDC Details', history, dispatch);
    }
  };
  React.useEffect(() => {
    if (
      getProviderList &&
      Object.keys(getProviderList).length > 0 &&
      providerIdTypeDropDown &&
      Object.keys(providerIdTypeDropDown).length > 0
    ) {
      const getIndex = providerIdTypeDropDown.findIndex(
        (element) =>
          element.codeValueID.codeValue === getProviderList[0]?.providerIdTypeCD
      );

      setProviderIdTypeDesc(providerIdTypeDropDown[getIndex]?.shortDescription);
    }
  }, [providerIdTypeDropDown, getProviderList]);
  //------------------------------------------
  const redirectToProvider = async (getProviderList) => {
    dispatch(getProviderIdTypeDetails());
    const response = await getProviderDetails({
      providerId: getProviderList[0]?.providerId,
      providerIdTypeCd: getProviderList[0]?.providerIdTypeCD,
    });
    if (response.message === 'SUCESS') {
      dispatch(dispatchProvideDetails(response?.data?.provider));
      redirectURLLink(
        '/ProviderDetails',
        'Provider Details',
        history,
        dispatch
      );
    }
  };
  // ---------------------Modify units Redirection API Call
  const GoToClaimDetail = async (data, searchScreenReduxObj) => {
    const resultData = await callSearchClaimAPI({
      rebateProgramCd: selectedRow.rebateProgramCd,
      searchByNdc: true,
      drugSqnNum: [data.drugSeqNum],
      paidQtr: selectedRow?.qtr,
    });
    if (resultData && resultData?.data?.length > 0) {
      dispatch(setSelectedClaimMode('maintain'));
      dispatch(getClaimTableInfo(true));
      dispatch(setSelectedClaim(resultData?.data));
      dispatch(
        setDisplayClaimSearchScreenObj({
          ...searchScreenReduxObj,
          isibwdndc: false,
          isibwdclaim: true,
        })
      );
      redirectURLLink('/selected-claim', 'Selected Claim', history, dispatch);
    }
  };

  // Go to Claims redirection API call-----------------------------------------
  const redirectToClaim = async (data, searchScreenReduxObj) => {
    const resultData = await callSearchClaimAPI({
      rebateProgramCd: selectedRow.rebateProgramCd,
      searchByNdc: true,
      drugSqnNum: [data.drugSeqNum],
      paidQtr: selectedRow?.qtr,
    });
    if (resultData && resultData?.data?.length > 0) {
      dispatch(setSelectedClaimMode('display'));
      dispatch(getClaimTableInfo(true));
      dispatch(setSelectedClaim(resultData?.data));
      dispatch(
        setDisplayClaimSearchScreenObj({
          ...searchScreenReduxObj,
          isibwdndc: false,
          isibwdclaim: true,
        })
      );
      redirectURLLink('/selected-claim', 'Selected Claim', history, dispatch);
    }
  };
  //------------------------------------------

  //------------------------------------------
  const handleCancel = () => {
    dispatch(dispatchBottonState(true));
    setFormValue({
      ...formValue,
      reviewTypeCd: getProviderList[0]?.reviewTypeCd,
      completeIndex: !!getProviderList[0]?.auditCompleteDt,
      frozenindex: !!getProviderList[0]?.reviewFreezeDt,
    });
    setDetailData({
      formValue: {
        ...formValue,
        reviewTypeCd: '-1',
        completeIndex: !!getProviderList[0]?.auditCompleteDt,
        frozenindex: !!getProviderList[0]?.reviewFreezeDt,
      },
    });
    dispatch(dispatchProblemCode(''));
    dispatch(dispatchcorrectionCode(''));
    dispatch(
      getProviderReviewClaimHeader({
        providerReviewSequenceNumber: getProviderList[0]?.providerReviewSeqNum,
      })
    );
    const result1 = dispatch(
      getReviewCorrectionDropdown({
        codeDomainList: ['REVW_CORRECTION_CD'],
      })
    );
    result1.then((item) => {
      setCorrectionDownReview(item?.REVW_CORRECTION_CD);
    });
    const result2 = dispatch(
      getReviewProblemDropdown({ codeDomainList: ['REVW_PROBLEM_CD'] })
    );
    result2.then((item) => {
      setProblemDownReview(item?.REVW_PROBLEM_CD);
    });

    setCancelView(false);
    setDisableSaveCancel(false);
  };
  //------------------------------------------
  const majorSave = () => {
    dispatch(
      updateProviderFrozenComplete({
        providerId: getProviderList[0]?.providerId,
        providerIdTypeCd: getProviderList[0]?.providerIdTypeCD,
        providerReviewSeqNum: getProviderList[0]?.providerReviewSeqNum,
        frozenChecked: formValue?.frozenindex ? '1' : '0',
        completeChecked: formValue?.completeIndex ? '1' : '0',
        reviewType: formValue?.reviewTypeCd,
        problemCd: getProblemCode || correctionTableData[0]?.problemCd,
        correctionCd: getCorrectionCode || correctionTableData[0]?.correctionCd,
        claimId: getproviderReviewClaimHeader[0]?.claimId,
        claimLineNum: getproviderReviewClaimHeader[0]?.claimLineNum,
        userId: logInUser,
      })
    );
    setSaveView(false);
    dispatch(dispatchBottonState(true));
  };
  const handleSave = (value) => {
    if (value) {
      setSaveView(true);
    } else {
      setHandleTab(true);
      majorSave();
    }
  };
  React.useEffect(() => {
    if (!handleTab) {
      const updateTabs = JSON.parse(localStorage.getItem('tabItemsData'));
      if (
        updateTabs &&
        updateTabs.length > 0 &&
        updateTabs.filter((x) => {
          return x.navTo === '/providerReviewDetail' && x.isFormSave;
        }).length > 0
      ) {
        const newObj = updateTabs.map((item) => {
          if (item.navTo === '/providerReviewDetail' && item.isFormSave) {
            item.isFormSave = false;
            handleSave(false);
          }
          return item;
        });
        localStorage.setItem('tabItemsData', JSON.stringify(newObj));
      }
    }
  }, [JSON.parse(localStorage.getItem('tabItemsData'))]);
  //------------------------------------------
  // default row
const onGridReady = (params) => {
  setGridApi(params.api);
  setGridParams(params);

  params.api.ensureIndexVisible(0);
  params.api.addEventListener('firstDataRendered', () => {
    if (getNdcTableData?.drugSeqNum) {
      params.api.forEachNode(
        (node) =>
          node?.data?.drugSeqNum == getNdcTableData?.drugSeqNum &&
          node?.setSelected(true)
      );
    } else {
      params.api.forEachNode(
        (node) => node?.rowIndex == 0 && node?.setSelected(true)
      );
    }
    const selectedRowNodes = params.api.getSelectedNodes();
    if (selectedRowNodes.length > 0) {
      onRowSelect(selectedRowNodes[0]?.data);
      setSelectedRow(selectedRowNodes[0]?.data);
    }
  });
};

  const onGridReadyForSecondGrid = (params) => {
    setGridParams(params);
  };

  //  row selection function
  const onRowSelect = (row) => {
    if (row?.drugSeqNum != getNdcTableData?.drugSeqNum) {
      dispatch(
        getProviderReviewClaimHeader({
          providerReviewSequenceNumber:
            getProviderList[0]?.providerReviewSeqNum,
        })
      );
      let result1 = dispatch(
        getReviewCorrectionDropdown({
          codeDomainList: ['REVW_CORRECTION_CD'],
        })
      );
      result1.then((item) => {
        setCorrectionDownReview(item?.REVW_CORRECTION_CD);
      });
      let result2 = dispatch(
        getReviewProblemDropdown({ codeDomainList: ['REVW_PROBLEM_CD'] })
      );
      result2.then((item) => {
        setProblemDownReview(item?.REVW_PROBLEM_CD);
      });
      setLoading(true);
    } else {
      dispatch(dispatchProviderReviewClaimHeader([]));
    }
  };

  return (
    <>
      <SaveCancelPopup
        open={cancelView}
        title='Cancel'
        data-testid='reset-button-uc'
        onConfim={handleCancel}
        onCancel={(e) => setCancelView(false)}
        moduleName=''
      />
      <SaveCancelPopup
        open={saveView}
        title='Save'
        data-testid='save-api-uc'
        onConfim={majorSave}
        onCancel={(e) => setSaveView(false)}
        moduleName=''
      />

      <div className='tabs-container tBillPanel'>
        <CustomSeparator parent1='Tasks' parent2='Provider Review Detail' />
        {!fullScreenView && (
          <>
            <DisplaySuccessMessages
              successMessages={[
                ...new Set(
                  errorMessagesInRedux?.detailScreenErrors?.length > 0
                    ? _.filter(
                        errorMessagesInRedux?.detailScreenErrors,
                        (l) => l.field === 'successMessage' && l.message
                      ).map((val) => val.message)
                    : []
                ),
              ]}
            />
            <DisplayErrorMessages
              errorMessages={[
                ...new Set(
                  errorMessagesInRedux?.detailScreenErrors?.length > 0
                    ? _.map(
                        errorMessagesInRedux.detailScreenErrors?.filter(
                          (item) => item.field !== 'successMessage'
                        ),
                        (l) => l.message
                      )
                    : []
                ),
              ]}
            />
            <Spinner load={loading} />
          </>
        )}

        {!fullScreenView ? (
          <div className='row mb-3' data-testid='provider-review-detail'>
            <div className='col-12'>
              <div className='provider-review-detail-btn-group welcometxt'>
                <div className='btn-wrapper'>
                  <Button
                    className='btn btn-success btn-save btn-primary'
                    data-testid='provider-review-detail-history'
                    onClick={() => {
                      handleViewHistory();
                    }}
                    disabled={false}
                  >
                    <SVGComponent iconName='Icon-view-history' /> View History
                  </Button>

                  <Button
                    disabled={getButtonState || !isEnablebyRole}
                    className='btn btn-success btn-save btn-primary'
                    onClick={() => handleSave(true)}
                    data-testid='provider-review-detail-save1'
                  >
                    <SVGComponent iconName='Icon-awesome-save' /> Save
                  </Button>
                  <Button
                    disabled={getButtonState}
                    className='btn btn-cancel btn btn-primary'
                    onClick={() => setCancelView(true)}
                    data-testid='provider-review-detail-cancel1'
                  >
                    <SVGComponent iconName='Icon-cancel' /> Cancel
                  </Button>
                </div>
                {showViewHistory && (
                  <ViewHistoryComponent
                    setShowViewHistory={setShowViewHistory}
                    tableName='PROVIDER'
                    keyValue={keyValue}
                    isSpinner
                  />
                )}
              </div>
            </div>
          </div>
        ) : (
          ''
        )}
        <PRDetailsForm
          handleOnChangeEvent={handleOnChangeEvent}
          formData={formData}
          loading={loading}
          formValue={formValue}
          setFormValue={setFormValue}
          providerIdTypeDesc={providerIdTypeDesc}
          getDetailData={getDetailData}
          providerDropDown={providerDropDown}
          showComments={showFormComments}
          setShowComments={setShowFormComments}
          corrLinkId={corrLinkFormId}
          setCorrLinkId={setCorrLinkFormId}
          linkTableName={linkFormTableName}
          setLinkTableName={setLinkFormTableName}
          setTableName={setTableFormName}
          fullScreenView={fullScreenView}
          fullScreenView1={fullScreenView1}
          setState={setState}
          setCorrectionState={setCorrectionState}
          isEnablebyRole={isEnablebyRole}
        />
        {!fullScreenView1 ? (
          <TableGrid
            data-testid='ndc-grid-table'
            rowSelection='multiple'
            rowMultiSelectWithClick={false}
            fullScreenView={fullScreenView}
            handleFullScreenViewClick={handleFullScreenView}
            gridHeight={fullScreenView ? '70vh' : viewPortHeight_355}
            navigateToNextCell={navigateToNextCell}
            tabToNextCell={tabToNextCell}
            hideColumnsInPdf={['action']}
            gridCall={onGridReady}
            onSelect={(e) => {
              onRowSelect(e.data);
              setSelectedRow(e?.data);
            }}
            enterMovesDown
            suppressCellFocus
            isScrollOn
            onCellFocused={onCellFocused}
            columnDefs={PRDetailTableHead1}
            rowData={getNdcTableData}
            exportFile
            fileName='Provider Review'
            animateRows
            frameworkComponents={{
              CheckBoxCellRender: (cellInfo) => {
                return (
                  <>
                    <div className='tbl-checkbox frr-checkbox-no-label'>
                      <FormControlLabel
                        data-testid='checkBox'
                        label='checkbox'
                        disabled
                        control={<Checkbox color='primary' />}
                        checked={parseInt(cellInfo.value, [0, 1]) === 1}
                        value={parseInt(cellInfo.value, [0, 1]) === 1}
                      />
                    </div>
                  </>
                );
              },
              DrugNameRenderer: (cellInfo) => {
                if (
                  cellInfo.value !== null &&
                  cellInfo.value !== '' &&
                  cellInfo?.value?.length > 20
                ) {
                  return (
                    <OverlayTrigger
                      placement='bottom'
                      overlay={
                        <Tooltip id='labeler-tooltip'>
                          {cellInfo.data.drugName}
                        </Tooltip>
                      }
                    >
                      <div>
                        {cellInfo.data.drugName &&
                          `${cellInfo.data.drugName.substring(0, 20)}...`}
                      </div>
                    </OverlayTrigger>
                  );
                }
                return <div>{cellInfo.value}</div>;
              },
              ActionCellRender: (cellInfo) => {
                // redirection go to Provider
                const getProviderListClaimTable = useSelector(
                  (state) =>
                    state.sharedState.ProviderReviewReducer?.getProviderList
                );
                return (
                  <>
                    <Dropdown className='icon-dropdown-container'>
                      <Dropdown.Toggle
                        className='icon-dropdown export_wrap'
                        aria-label='export'
                      >
                        <OverlayTrigger
                          placement='bottom'
                          overlay={
                            <Tooltip id='action-tooltip'>Actions</Tooltip>
                          }
                        >
                          <SVGComponent iconName='Icon-export1' />
                        </OverlayTrigger>
                      </Dropdown.Toggle>
                      <Dropdown.Menu className='export_dropdown'>
                        <Dropdown.Item
                          role='button'
                          onClick={() => redirectToNDC(cellInfo.data)}
                        >
                          {' '}
                          Go to NDC{' '}
                        </Dropdown.Item>
                        <Dropdown.Item
                          role='button'
                          onClick={() =>
                            redirectToProvider(getProviderListClaimTable)
                          }
                        >
                          Go to Provider{' '}
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  </>
                );
              },
            }}
          />
        ) : (
          ''
        )}
        {probelemDropDownReview &&
        probelemDropDownReview.length > 0 &&
        correctionDropDownReview &&
        correctionDropDownReview.length > 0 ? (
          <TableGrid
            data-testid='provider-grid-table'
            rowSelection='multiple'
            rowMultiSelectWithClick={false}
            gridCall={onGridReadyForSecondGrid}
            fullScreenView={fullScreenView1}
            handleFullScreenViewClick={handleFullScreenView1}
            gridHeight={fullScreenView1 ? '70vh' : viewPortHeight_355}
            navigateToNextCell={navigateToNextCell}
            tabToNextCell={tabToNextCell}
            enterMovesDown
            onCellValueChanged={(e) => cellValueUpdateCustom(e)}
            suppressCellFocus
            isScrollOn
            onCellFocused={onCellFocused}
            columnDefs={PRDetailTableHead2}
            rowData={correctionTableData}
            frameworkComponents={{
              ActionCellRender: (cellInfo) => {
                // redirection go to Provider/NDC
                const getProviderListClaimTable = useSelector(
                  (state) =>
                    state.sharedState.ProviderReviewReducer?.getProviderList
                );
                const searchScreenReduxObj = useSelector(
                  (state) => state.sharedState.claim?.searchScreenReduxObj
                );
                return (
                  <>
                    <div className='tdCell icon-btn-group'>
                      <OverlayTrigger
                        placement='bottom'
                        overlay={<Tooltip id='com-tooltip'>Comment</Tooltip>}
                      >
                        <Button
                          type='button'
                          data-testid='test-comm-dfd'
                          onClick={() => {
                            setCorrLinkId(cellInfo && cellInfo.data.corrLinkId);
                            setLinkTableName('PROVIDER_REVIEW');
                            setTableName('');
                            setShowComments(true);
                          }}
                          tabIndex={'0'}
                          onKeyDown={(e) => {
                            // Handle Enter and Space key events
                            if (e.key === 'Enter' || e.key === ' ') {
                              e.preventDefault(); // Prevents the default space scrolling behavior
                              setCorrLinkId(
                                cellInfo && cellInfo.data.corrLinkId
                              );
                              setLinkTableName('PROVIDER_REVIEW');
                              setTableName('');
                              setShowComments(true);
                            }
                          }}
                          className={`th-ic comment-ic ${
                            parseInt(cellInfo.data.ccCommentsExist, 10) ===
                            1
                              ? 'frr-enabled-comment-btn '
                              : 'frr-disabled-comment-btn'
                          }`}
                          variant='text'
                        >
                          {parseInt(cellInfo.data.ccCommentsExist, 10) ===
                          1 ? (
                            <img
                              aria-label='comment'
                              src={CommentVisibleIcon}
                            />
                          ) : (
                            <img aria-label='comment' src={CommentIcon} />
                          )}
                        </Button>
                      </OverlayTrigger>
                      <Dropdown className='icon-dropdown-container float-left'>
                        <Dropdown.Toggle
                          className='icon-dropdown export_wrap'
                          aria-label='export'
                        >
                          <OverlayTrigger
                            placement='bottom'
                            overlay={
                              <Tooltip id='action-tooltip'>Actions</Tooltip>
                            }
                          >
                            <SVGComponent iconName='Icon-export1' />
                          </OverlayTrigger>
                        </Dropdown.Toggle>
                        <Dropdown.Menu className='export_dropdown'>
                          <Dropdown.Item
                            role='button'
                            onClick={() => redirectToNDC(getNdcTableData[0])}
                          >
                            {' '}
                            Go to NDC{' '}
                          </Dropdown.Item>
                          <Dropdown.Item
                            role='button'
                            onClick={() =>
                              redirectToProvider(getProviderListClaimTable)
                            }
                          >
                            Go to Provider{' '}
                          </Dropdown.Item>
                          <Dropdown.Item

                            role='button'
                            onClick={() => GoToClaimDetail(cellInfo.data)}

                          >
                            Modify Units
                          </Dropdown.Item>
                          <Dropdown.Item

                            role='button'
                            onClick={() => redirectToClaim(cellInfo.data)}

                          >
                            {' '}
                            Go to Claim
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                    </div>
                  </>
                );
              },
              CorrectionCellRenderer: (cellInfo) => (
                <CorrectionCodeDropdown
                  cellInfo={cellInfo}
                  correctionCode
                  handleOnChangeEvent={handleOnChangeEvent}
                  // setDisablemajorButton={setDisablemajorButton}
                  setFormValue={setFormValue}
                  formValue={formValue}
                  correctionDropDownReview={correctionDropDownReview}
                  isEnablebyRole={isEnablebyRole}
                />
              ),
              ProblemCellRenderer: (cellInfo) => (
                <ProblemCodeDropdown
                  cellInfo={cellInfo}
                  problemCode
                  setFormValue={setFormValue}
                  // setDisablemajorButton={setDisablemajorButton}
                  handleOnChangeEvent={handleOnChangeEvent}
                  formValue={formValue}
                  probelemDropDownReview={probelemDropDownReview}
                  isEnablebyRole={isEnablebyRole}
                />
              ),
              CorrectionAmtCellRender1: (cellInfo) => {
                let isNegativeVal = false;
                const value = cellInfo?.data?.origNumOfUnits;
                if (value && value !== 0 && value < 0) {
                  isNegativeVal = !(
                    parseFloat(cellInfo?.data?.origNumOfUnits) >= 0
                  );
                }

                return (
                  <>
                    {isNegativeVal ? (
                      <div style={{ color: RedColor }}>
                        {('( ' + cellInfo?.data?.origNumOfUnits + ')')
                          .replace('-', '')
                          .trim()}
                      </div>
                    ) : (
                      <div>{` ${cellInfo?.data?.origNumOfUnits}`}</div>
                    )}
                  </>
                );
              },
              CorrectionAmtCellRender2: (cellInfo) => {
                let isNegativeVal = false;
                const value = cellInfo?.data?.numOfUnits;
                if (value && value !== 0 && value < 0) {
                  isNegativeVal = !(
                    parseFloat(cellInfo?.data?.numOfUnits) >= 0
                  );
                }

                return (
                  <>
                    {isNegativeVal ? (
                      <div style={{ color: RedColor }}>
                        {('( ' + cellInfo?.data?.numOfUnits + ')')
                          .replace('-', '')
                          .trim()}
                      </div>
                    ) : (
                      <div>{` ${cellInfo?.data?.numOfUnits}`}</div>
                    )}
                  </>
                );
              },
              CorrectionAmtCellRender3: (cellInfo) => {
                let isNegativeVal = false;
                const value = cellInfo?.data?.allowedAmt;
                if (value && value !== 0 && value < 0) {
                  isNegativeVal = !(
                    parseFloat(cellInfo?.data?.allowedAmt) >= 0
                  );
                }

                return (
                  <>
                    {isNegativeVal ? (
                      <div style={{ color: RedColor }}>
                        {('($ ' + cellInfo?.data?.allowedAmt + ')')
                          .replace('-', '')
                          .trim()}
                      </div>
                    ) : (
                      <div>{`$ ${cellInfo?.data?.allowedAmt}`}</div>
                    )}
                  </>
                );
              },
              CorrectionAmtCellRender4: (cellInfo) => {
                let isNegativeVal = false;
                const value = cellInfo?.data?.submittedAmt;
                if (value && value !== 0 && value < 0) {
                  isNegativeVal = !(
                    parseFloat(cellInfo?.data?.submittedAmt) >= 0
                  );
                }

                return (
                  <>
                    {isNegativeVal ? (
                      <div style={{ color: RedColor }}>
                        {('($ ' + cellInfo?.data?.submittedAmt + ')')
                          .replace('-', '')
                          .trim()}
                      </div>
                    ) : (
                      <div>{`$ ${cellInfo?.data?.submittedAmt}`}</div>
                    )}
                  </>
                );
              },
              CorrectionAmtCellRender5: (cellInfo) => {
                let isNegativeVal = false;
                const value = cellInfo?.data?.reimbursementAmt;
                if (value && value !== 0 && value < 0) {
                  isNegativeVal = !(
                    parseFloat(cellInfo?.data?.reimbursementAmt) >= 0
                  );
                }

                return (
                  <>
                    {isNegativeVal ? (
                      <div style={{ color: RedColor }}>
                        {('($ ' + cellInfo?.data?.reimbursementAmt + ')')
                          .replace('-', '')
                          .trim()}
                      </div>
                    ) : (
                      <div>{`$ ${cellInfo?.data?.reimbursementAmt}`}</div>
                    )}
                  </>
                );
              },
            }}
            exportFile
            fileName='Provider Review'
            animateRows
          />
        ) : (
          ''
        )}
        {showComments ? (
          <CommentAndCorrespondenceComponent
            setShowComments={setShowComments}
            linkTableName={linkTableName}
            corrLinkId={corrLinkId}
          />
        ) : null}
        <div className='row mb-3'>
          <div className='col-12'>
            <div className='provider-review-detail-btn-group welcometxt'>
              <div className='btn-wrapper'>
                <Button
                  disabled={getButtonState}
                  className='btn btn-success btn-save btn-primary'
                  onClick={() => handleSave(true)}
                  data-testid='provider-review-detail-save'
                >
                  <SVGComponent iconName='Icon-awesome-save' /> Save
                </Button>
                <Button
                  disabled={getButtonState}
                  className='btn btn-cancel btn btn-primary'
                  onClick={() => setCancelView(true)}
                  data-testid='provider-review-detail-cancel'
                >
                  <SVGComponent iconName='Icon-cancel' /> Cancel
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ProviderReviewDetail;
